import Decimal from "decimal.js";
import capitalize from "lodash-es/capitalize";
import { tryParseDecimal } from "shared/utils/DecimalUtils";

export const formatPercentage = (value: string | Decimal, decimalPlaces = 2) =>
  `${(value instanceof Decimal ? value : new Decimal(value)).toFormat(
    decimalPlaces,
  )}%`;

export const formatPercentageForTable = (value?: string, decimalPlaces = 2) => {
  const decimal = tryParseDecimal(value);
  return !decimal || decimal.isNaN() || decimal.isZero()
    ? "-"
    : formatPercentage(decimal, decimalPlaces);
};

export const naiveFormatEnumValue = (value: string) =>
  value
    .split("_")
    .map((element) => capitalize(element))
    .join(" ");
